import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

export interface ConsultaLegal {
    titulo: string;
    detalle?: string;
    fechaApertura: string;
    tramitador: string;
    estado: string;
    eventYear?: string;
    expedienteNumero?: string;
}

@Component({
    selector: 'app-consultas',
    templateUrl: './consultas.component.html',
    styleUrls: ['./consultas.component.scss']
})
export class ConsultasComponent {

    @Input() consultas: ConsultaLegal[] = [];
    @Input() loading: boolean = false;

    skeletonSlots: number[] = [0, 1, 2];

    detailOpen: boolean = false;
    selectedConsulta: ConsultaLegal = null;

    constructor(private router: Router) {}

    get items(): ConsultaLegal[] {
        return (this.consultas || []).slice(0, 3);
    }

    irA(link: string): void {
        this.router.navigate([link]);
    }

    /** Abre el modal con el detalle de la consulta seleccionada. */
    irDetalle(consulta: ConsultaLegal): void {
        this.selectedConsulta = consulta;
        this.detailOpen = true;
    }

    closeDetail(): void {
        this.detailOpen = false;
        this.selectedConsulta = null;
    }
}
